import http from "../config/http-configs";

export const getAreaList = () => {
    return http.get('/mobile/device/area/list/all')
}
